import { render, staticRenderFns } from "./section-time.vue?vue&type=template&id=188099f2&scoped=true"
import script from "./section-time.vue?vue&type=script&lang=js"
export * from "./section-time.vue?vue&type=script&lang=js"
import style0 from "./section-time.vue?vue&type=style&index=0&id=188099f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188099f2",
  null
  
)

export default component.exports